import "./ButtonWithLoading.css";
import { Button, ButtonProps, CircularProgress } from "@material-ui/core";
import LoadingButton from "./LoadingButton";

interface ButtonWithLoadingProps {
  buttonClickText: string;
  buttonFinishedText: string;
  clickHandler: () => void;
  loadingButtonState: LoadingButton;
  changeLoadingButtonState: (loadingState: LoadingButton) => void;
  img?: string;
  imgAlt?: string;
  imgStyles?: object;
}

// Button can accept parameters of Material UI's Button
const ButtonWithLoading = (props: ButtonWithLoadingProps & ButtonProps) => {
  // *Three loadingButtonState states* use the enum LoadingButton:
  // LoadingButton.BeforeLoading, LoadingButton.Loading, LoadingButton.DoneLoading
  // If call to db is successful, set loadingButtonState to LoadingButton.DoneLoading where call occurs
  // If call to db is unsuccessful, set loadingButtonState to LoadingButton.BeforeLoading where error occurs

  // If parent component is functional,
  // place these two functions in parent component
  // And pass changeLoadingState into the button:
  //
  // const [loadingButtonState, setLoadingButtonState] = useState(LoadingButton.BeforeLoading)
  //
  // const changeLoadingButtonState = (loadingState: LoadingButton) => {
  //     setLoadingButtonState(loadingState)
  // }

  // If parent is class component,
  // add loadingButtonState to state, with the initial value set at LoadingButton.BeforeLoading
  // Also add this function to parent:
  //
  // changeLoadingState = (loadingState: LoadingButton) => {
  //     this.setState(state => {
  //         return {
  //             ...state,
  //             loadingButtonState: loadingState
  //         }
  //     })
  // }
  // *** MAKE SURE TO BIND THE CLICK HANDLER FUNCTION'S THIS ***
  // The easiest way to do this is to make the click handler function an arrow function

  // Material UI defaults to capitalizing all letters in button text
  // Turn this off by adding the following to property to Button
  //
  // style={{textTransform: "none"}}

  // Remove all of the props we don't want to pass to Button so we can just use pass-through to get
  // all of our button properties
  const {
    clickHandler,
    buttonClickText,
    buttonFinishedText,
    loadingButtonState,
    changeLoadingButtonState,
    img,
    imgAlt,
    imgStyles,
    ...passedThroughProps
  } = props;

  const handleClick = () => {
    changeLoadingButtonState(LoadingButton.Loading);
    clickHandler();
  };

  return (
    <Button {...passedThroughProps} disabled={loadingButtonState !== LoadingButton.BeforeLoading} onClick={handleClick}>
      {img && loadingButtonState !== LoadingButton.Loading ? (
        <img className="ButtonWithLoadingImage" alt={imgAlt} style={imgStyles} src={img} />
      ) : (
        ""
      )}
      {loadingButtonState === LoadingButton.BeforeLoading ? <div>{buttonClickText}</div> : ""}
      {loadingButtonState === LoadingButton.Loading ? <CircularProgress size={24} /> : ""}
      {loadingButtonState === LoadingButton.DoneLoading ? <div>{buttonFinishedText}</div> : ""}
    </Button>
  );
};

export default ButtonWithLoading;
